import {Link, useParams} from "react-router-dom";
import React, {useEffect} from "react";
import OrderStatusCard from "../components/OrderStatusCard";
import {publicApi} from "../api";
import axios from "axios";
import {toast} from "react-toastify";

type OrderStatus = {
    status: string;
    creationTimestamp: string;
}

type RetrieveStatusHistory = {
    status: string;
    code: number;
    message: string;
    statusHistory: OrderStatus[];
}

function CustomerView() {
    localStorage.removeItem("focus")
    const {orderId} = useParams<{ orderId: string }>();

    const [history, setHistory] = React.useState<OrderStatus[]>([]);

    const loadOrderHistory = async () => {
        try {
            const res = await publicApi.get <RetrieveStatusHistory>(`/v1/order/${orderId}/history`);
            setHistory(res.data.statusHistory ?? []);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    }

    useEffect(() => {
        loadOrderHistory();

    }, []);

    return (
        <div className="bg-blue-50 flex items-center justify-center min-h-screen">
            <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-md">
                {/*Title*/}
                <h2 className="text-3xl font-bold text-center text-blue-600 mb-6">
                    Casablanca Riparazioni
                </h2>
                <h2 className="font-bold text-center text-black-600 mb-6">
                    Ordine: {orderId}
                </h2>

                <div className="space-y-6">
                    {history.map((status: OrderStatus) => {
                        return <OrderStatusCard date={status.creationTimestamp} status={status.status}/>;
                    })}
                    <div className="flex items-center justify-end text-sm">
                        <Link to={`/order/${orderId}`} className="text-blue-600 hover:underline">Gestisci ordine</Link>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default CustomerView;